var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankYouIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.04,
    y1: 0.063,
    x2: 0.979,
    y2: 0.941,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffad46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d37c51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#903163"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(-834 -144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_9532",
    "data-name": "Path 9532",
    transform: "translate(834 144)",
    fill: "none",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,0A62,62,0,1,1,0,62,62,62,0,0,1,62,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 1 C 53.76461791992188 1 45.77610015869141 2.612686157226562 38.25634765625 5.793266296386719 C 34.64206695556641 7.321983337402344 31.15601348876953 9.214164733886719 27.89501953125 11.41725158691406 C 24.66474914550781 13.59958648681641 21.62711334228516 16.10586547851562 18.86648559570312 18.86648559570312 C 16.10586547851562 21.62711334228516 13.59958648681641 24.66474914550781 11.41725158691406 27.89501953125 C 9.214164733886719 31.15601348876953 7.321983337402344 34.64206695556641 5.793266296386719 38.25634765625 C 2.612686157226562 45.77610015869141 1 53.76461791992188 1 62 C 1 70.23538208007812 2.612686157226562 78.22389984130859 5.793266296386719 85.74365234375 C 7.321983337402344 89.35793304443359 9.214164733886719 92.84397888183594 11.41725158691406 96.10498046875 C 13.59958648681641 99.33525085449219 16.10586547851562 102.3728790283203 18.86648559570312 105.1335144042969 C 21.62711334228516 107.8941345214844 24.66474914550781 110.4004135131836 27.89501953125 112.5827484130859 C 31.15601348876953 114.7858352661133 34.64206695556641 116.6780166625977 38.25634765625 118.2067337036133 C 45.77610015869141 121.3873138427734 53.76461791992188 123 62 123 C 70.23538208007812 123 78.22389984130859 121.3873138427734 85.74365234375 118.2067337036133 C 89.35793304443359 116.6780166625977 92.84397888183594 114.7858352661133 96.10498046875 112.5827484130859 C 99.33525085449219 110.4004135131836 102.3728790283203 107.8941345214844 105.1335144042969 105.1335144042969 C 107.8941345214844 102.3728790283203 110.4004135131836 99.33525085449219 112.5827484130859 96.10498046875 C 114.7858352661133 92.84397888183594 116.6780166625977 89.35793304443359 118.2067337036133 85.74365234375 C 121.3873138427734 78.22389984130859 123 70.23538208007812 123 62 C 123 53.76461791992188 121.3873138427734 45.77610015869141 118.2067337036133 38.25634765625 C 116.6780166625977 34.64206695556641 114.7858352661133 31.15601348876953 112.5827484130859 27.89501953125 C 110.4004135131836 24.66474914550781 107.8941345214844 21.62711334228516 105.1335144042969 18.86648559570312 C 102.3728790283203 16.10586547851562 99.33525085449219 13.59958648681641 96.10498046875 11.41725158691406 C 92.84397888183594 9.214164733886719 89.35793304443359 7.321983337402344 85.74365234375 5.793266296386719 C 78.22389984130859 2.612686157226562 70.23538208007812 1 62 1 M 62 0 C 96.24165344238281 0 124 27.75834655761719 124 62 C 124 96.24165344238281 96.24165344238281 124 62 124 C 27.75834655761719 124 0 96.24165344238281 0 62 C 0 27.75834655761719 27.75834655761719 0 62 0 Z",
    stroke: "none",
    fill: "#f26c21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(845 154)",
    fill: "none",
    stroke: "#f26c21",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    transform: "translate(856 165)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9531",
    "data-name": "Path 9531",
    d: "M9948.756,346.753l12.33,14.975,20.735-24.65",
    transform: "translate(-9069.256 -143.578)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouIcon);
export default __webpack_public_path__ + "static/media/thank-you-icon.06c0aac5d42cbeb3e7a699ad06c53a6c.svg";
export { ForwardRef as ReactComponent };